import { FC } from "react";
import { Tender, Tendering } from "../../../models/tendering";
import TenderFacts from "./TenderFacts";

interface TenderHiddenFactsProps {
  tenderDocument: Tender;
  tenderingDocument: Tendering;
  updateTender?: (tender: Tender) => void;
}

const TenderHiddenFacts: FC<TenderHiddenFactsProps> = (props) => {
  return (
    <TenderFacts
      tenderDocument={props.tenderDocument}
      tendering={props.tenderingDocument}
      updateTender={props.updateTender}
      mode="hidden"
    />
  );
}

export default TenderHiddenFacts;
